import { t } from 'i18next';
import { Svgs } from '../../../../../../assets/svg';
import { Row } from '../../../../../../components';
import UpsellCard from '../../UpsellCard';

const MobileUpsellCards: React.FC = () => {
  return (
    <Row
      style={{
        marginBottom: '80px',
        justifyContent: 'center',
      }}>
      <UpsellCard
        art={<Svgs.ArtCardCash />}
        title={t('Cash')}
        cardStyle={{ marginRight: '-20px', zIndex: 2 }}
        mobile
      />
      <UpsellCard
        art={<Svgs.ArtCardBonds />}
        title={t('Bonds')}
        cardStyle={{ marginTop: '50px', marginBottom: '-50px', zIndex: 3 }}
        mobile
      />
      <UpsellCard
        art={<Svgs.ArtCardStocks />}
        title={t('Stocks')}
        cardStyle={{ marginLeft: '-20px', zIndex: 2 }}
        mobile
      />
    </Row>
  );
};

export default MobileUpsellCards;
